import { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";

interface PublicViewRouteProps {
  component: React.ComponentType<any>;
  redirectRoute: string;
  children?: React.ReactNode;
  location?: any;
  auth?: any;
}

/**
 * @prop { object } subjectTopics
 * @prop { object } user
 * @prop { object } auth
 * @desc Public view route redirects user if they are authenticated
 */
const PublicViewRoute: FC<PublicViewRouteProps> = (props: any) => {
  const { component: Component, children, location, redirectRoute } = props;

  const { keycloak, initialized } = useKeycloak();
  const [validTokens, setValidTokens] = useState(false);
  const currentLocation = useLocation();

  useEffect(() => {
    if (initialized && keycloak.authenticated) {
      keycloak
        .updateToken(30)
        .success(() => {
          setValidTokens(true);
        })
        .error(() => {
          setValidTokens(false);
        });
    }
  }, [initialized, keycloak]);

  const locationToUse = location || currentLocation;

  return keycloak.authenticated && validTokens ? (
    <Navigate to={`${redirectRoute}${locationToUse?.search ?? ""}`} />
  ) : (
    <Component {...props}>{children}</Component>
  );
};

const mapStateToProps = (state: any) => ({
  auth: state.auth.account,
});

export default connect(mapStateToProps)(PublicViewRoute);
